import { render, staticRenderFns } from "./StudentSupportList.vue?vue&type=template&id=40106ffe&scoped=true&"
import script from "./StudentSupportList.vue?vue&type=script&lang=js&"
export * from "./StudentSupportList.vue?vue&type=script&lang=js&"
import style0 from "./StudentSupportList.vue?vue&type=style&index=0&id=40106ffe&lang=scss&scoped=true&"
import style1 from "./StudentSupportList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40106ffe",
  null
  
)

export default component.exports